module.exports = __webpack_public_path__ + "img/Inflammation-CRC_GSE206552.571d0c34.png";